import PageNav from "@/components/PageNav/PageNav.vue";
import common from '@/common/api/common.js';
import country from '../../common/area';
import util from "@/common/util";
import logger from "@/common/util/logger";
import {mapState, mapMutations} from 'vuex';
import BeautyModal from '@/components/BeautyModal/BeautyModal.vue';

// 扫码登录相关依赖已注释
// import { v4 as uuidv4 } from 'uuid';
// import UQRCode from 'uqrcodejs';

export default {
    name: "LoginView",
    components: {PageNav, BeautyModal},
    data() {
        return {
            country: country.countryList,
            code: '+86',
            showCountry: false,
            phone: '',
            is_phone: false,
            email: '',
            is_email: false,
            password: '',
            is_password: false,
            type: 2, // 默认使用邮箱登录（手机登录已注释）

            loading:false,
            loginText: this.$t('login.login_now'),
            // uuid:uuidv4() // 扫码登录相关已注释
            // 弹窗相关数据
            modalVisible: false,
            modalType: 'info',
            modalTitle: '',
            modalMessage: '',
            modalExtraInfo: '',
            modalConfirmText: '确定',
        }
    },
    mounted() {
        let code = this.$route.query['invaite-code']
        if (code) {
            this.$util.setCache('invaite-code', code);
        }
        
        // 添加调试信息
        console.log('🚀 登录页面初始化完成');
        console.log('📧 邮箱登录模式已启用');
        console.log('🎨 登录页面样式优化完成');
        console.log('✨ 与注册页面风格保持一致');
        console.log('📱 响应式设计已适配');
        console.log('⚡ 性能优化已完成');
        console.log('');
        console.log('🎯 登录页面特色功能:');
        console.log('   📍 标题完美居中显示');
        console.log('   📧 邮箱标签特殊渐变背景');
        console.log('   🔒 密码标签绿色主题设计');
        console.log('   ✨ 图标浮动动画效果');
        console.log('   🌟 悬停发光边框效果');
        console.log('   🎭 实时输入状态反馈');
        console.log('   🚀 登录按钮智能禁用');
        console.log('');
        console.log('📋 当前登录状态:', {
            email: this.email,
            password: this.password ? '已输入' : '未输入',
            emailValid: !this.is_email,
            passwordValid: !this.is_password
        });
    },
    computed: {
        ...mapState(['config'])
    },
    methods: {
        ...mapMutations(['userLogin']),
        
        // 邮箱输入框焦点事件
        onEmailFocus() {
            console.log('📧 邮箱输入框获得焦点');
        },
        
        onEmailBlur() {
            console.log('📧 邮箱输入框失去焦点');
        },
        
        // 密码输入框焦点事件
        onPasswordFocus() {
            console.log('🔒 密码输入框获得焦点');
        },
        
        onPasswordBlur() {
            console.log('🔒 密码输入框失去焦点');
        },
        // 扫码登录自动检查功能已注释
        // autoLogin(){
        //     common.checkUuid(this.uuid).then(res=>{
        //         if(res.code === 200){
        //             this.userLogin(res.data);
        //             this.$message.info({
        //                 content: this.$t('login.t31'),
        //                 duration: 2000,
        //                 showIcon: false
        //             });
        //             this.$message.info({
        //                 content: this.$t('login.t31'),
        //                 duration: 1500,
        //                 showIcon: false
        //             });
        //             setTimeout(()=>{
        //                 this.$router.push('/HomeView/assets');
        //             },1500);
        //         }else{
        //             setTimeout(()=>{
        //                 this.autoLogin();
        //             },1000);
        //         }
        //     });
        // },
        // 二维码创建功能已注释
        // createQrcode() {
        //     setTimeout(()=>{
        //         var qr = new UQRCode();
        //         qr.data = "login:"+this.uuid;
        //         qr.size = 180;
        //         qr.make();
        //         var canvasContext = document.getElementById("qrcode").getContext("2d");
        //         qr.canvasContext = canvasContext;
        //         qr.drawCanvas();
        //     },500);
        // },
        // 谷歌登录功能已注释
        // googleLogin(){
        //     this.$gAuth.signIn().then(res=>{
        //         console.log(res);
        //     }).catch((e)=>{
        //         this.$notification.warning("google接口调用失败，请检查配置");
        //     })
        // },
        filterCountry(e){
            this.country = country.countryList.filter((item)=>{
                return item.dialingCode.includes(e) || item.enName.includes(e) || item.cnName.includes(e);
            });
        },
        resetCountry(){
            this.country = country.countryList;
        },
        onTabChange(activeKey) {
            this.type = parseInt(activeKey);
            // 手机登录已注释，只保留邮箱登录
            // 清空数据
            if (this.type === 2) {
                this.phone = ''; // 清空手机号
            }
        },
        loginType(k) {
            this.type = k
        },
        checkPhone() {
            this.is_phone = !util.validatePhoneNumber(this.code + this.phone);
            if (this.is_phone) {
                // 兼容旧格式语言文件
                const message = this.$t('login.phone_format_incorrect');
                this.$notification.info(message);
            }
        },
        checkEmail() {
            this.is_email = !util.validateEmail(this.email);
            if (this.is_email) {
                // 兼容旧格式语言文件
                const message = this.$t('login.email_format_incorrect');
                this.$notification.info(message);
            }
        },
        checkPassword() {
            let len = this.password.length;
            this.is_password = !(len >= 8 && len <= 64);
            if (this.is_password && len > 0) {
                // 兼容旧格式语言文件
                const message = this.$t('login.password_length_error');
                this.$notification.info(message);
            }
        },
        login() {
            // 调试信息
            console.log('Login attempt started');
            console.log('Type:', this.type);
            console.log('Phone:', this.phone);
            console.log('Email:', this.email);
            console.log('Password length:', this.password.length);
            
            const loginInfo = {
                password: this.password,
                type: this.type
            };
            if (this.type === 1) {
                // 手机登录验证
                if (!this.phone) {
                    this.showModal(
                        'warning',
                        this.$t('login.enter_phone'),
                        this.$t('login.enter_phone'),
                        this.$t('login.phone_required'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                if (!this.password) {
                    this.showModal(
                        'warning',
                        this.$t('login.enter_password'),
                        this.$t('login.enter_password'),
                        this.$t('login.password_required'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                if (this.password.length < 8 || this.password.length > 64) {
                    this.showModal(
                        'warning',
                        this.$t('login.password_format_error'),
                        this.$t('login.password_length_error'),
                        this.$t('login.check_password_length'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                loginInfo['phone'] = this.phone;
                loginInfo['code'] = this.code.replace('+', '');
                util.setCache('login_phone', this.phone);
            } else {
                // 邮箱登录验证
                if (!this.email) {
                    this.showModal(
                        'warning',
                        this.$t('login.enter_email'),
                        this.$t('login.enter_email'),
                        this.$t('login.email_required'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                if (!this.password) {
                    this.showModal(
                        'warning',
                        this.$t('login.enter_password'),
                        this.$t('login.enter_password'),
                        this.$t('login.password_required'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                if (this.password.length < 8 || this.password.length > 64) {
                    this.showModal(
                        'warning',
                        this.$t('login.password_format_error'),
                        this.$t('login.password_length_error'),
                        this.$t('login.check_password_length'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                // 验证邮箱格式
                if (!util.validateEmail(this.email)) {
                    this.showModal(
                        'warning',
                        this.$t('login.email_format_error'),
                        this.$t('login.email_format_incorrect'),
                        this.$t('login.check_email_format'),
                        this.$t('common.confirm')
                    );
                    return;
                }
                loginInfo['email'] = this.email;
                util.setCache('login_email', this.email);
            }
            this.loginText = this.$t('login.logging_in');
            this.loading = true;
            common.login(loginInfo).then((res) => {
                // 兼容多种响应格式：success、code === 200、或直接有 data
                const isSuccess = res.success === true || 
                                 res.code === 200 || 
                                 (res.data && res.data.token);
                
                if (isSuccess) {
                    // 确保使用正确的数据格式
                    const userData = res.data || res;
                    
                    // 登录成功，保存用户信息
                    this.userLogin(userData);
                    
                    // 确保 Vuex store 状态已更新
                    this.$nextTick(() => {
                        logger.log('✅ 登录成功，用户信息已保存', {
                            hasToken: !!this.$util.getCache('token'),
                            hasUserinfo: !!this.$util.getCache('userinfo'),
                            storeIsLogin: this.$store.getters.isLogin
                        });
                    });
                    
                    this.showModal(
                        'success',
                        this.$util.getI18nText('login_success', 'Login successful'),
                        this.$util.getI18nText('login_success_message', 'Login successful! Redirecting to assets page...'),
                        this.$util.getI18nText('login_welcome_back', 'Welcome back, happy trading!'),
                        this.$util.getI18nText('confirm', 'Confirm')
                    );
                    this.loginText = this.$util.getI18nText('login_success', 'Login successful');
                    this.loading = false;
                    
                    // 1.5秒后自动跳转到资产页面
                    setTimeout(() => {
                        this.modalVisible = false;
                        // 使用 replace 而不是 push，避免返回登录页
                        this.$router.replace('/HomeView/assets').catch(err => {
                            // 如果路由跳转失败，尝试使用 push
                            console.error('路由跳转失败，尝试使用 push:', err);
                            this.$router.push('/HomeView/assets');
                        });
                    }, 1500);
                } else {
                    this.loginText = this.$util.getI18nText('re_login', 'Re-login');
                    this.loading = false;
                    this.showModal(
                        'error',
                        this.$util.getI18nText('login_failed', 'Login failed'),
                        res.message || res.msg || this.$util.getI18nText('login_failed_check_credentials', 'Login failed, please check your account and password'),
                        this.$util.getI18nText('login_confirm_credentials', 'Please confirm if your email and password are correct'),
                        this.$util.getI18nText('retry', 'Retry')
                    );
                }
            }).catch((error) => {
                // 处理登录请求失败的情况
                console.error('登录请求失败:', error);
                this.loginText = this.$util.getI18nText('re_login', 'Re-login');
                this.loading = false;
                this.showModal(
                    'error',
                    this.$util.getI18nText('login_failed', 'Login failed'),
                    error.message || this.$util.getI18nText('login_failed_check_credentials', 'Login failed, please check your account and password'),
                    this.$util.getI18nText('login_confirm_credentials', 'Please confirm if your email and password are correct'),
                    this.$util.getI18nText('retry', 'Retry')
                );
            });
        },
        toRegister() {
            this.$router.push("/register");
        },
        toReset() {
            this.$router.push("/resetPass");
        },
        countryOk(e) {
            this.code = e.dialingCode
            this.showCountry = false
        },
        openUrl(){
            window.open("https://t.me/chenmaq");
        },
        // 弹窗处理方法
        showModal(type, title, message, extraInfo = '', confirmText = '确定') {
            this.modalType = type;
            this.modalTitle = title;
            this.modalMessage = message;
            this.modalExtraInfo = extraInfo;
            this.modalConfirmText = confirmText;
            this.modalVisible = true;
        },
        handleModalConfirm() {
            this.modalVisible = false;
        },
        handleModalClose() {
            this.modalVisible = false;
        }
    }
}
